import './Navbar.css';
import TMALogo from "../../assets/toyota-asia-logo.png";
import { useDispatch, useSelector } from "react-redux";
import { clearSession, selectUserName } from "../../store/sessionSlice";
import { auth } from "../../utils/firebase";
import { signOut } from "firebase/auth";

import { Button, Popover } from "antd";
import { useLocation, useNavigate } from 'react-router-dom';

const Navbar = () => {
    const userName = useSelector(selectUserName);

    const { pathname } = useLocation();
    const navigate = useNavigate();

    const onHistory = pathname.startsWith("/history");

    const label = onHistory ? "Home" : "History";
    const target = onHistory ? "/home" : "/history";

    const dispatch = useDispatch();

    const handleLogout = async () => {
        try {
            dispatch(clearSession());
            await signOut(auth);
        } catch (e) {
            console.error("Logout error:", e);
        } finally {
            navigate("/");
            window.location.reload();
        }
    };

    const content = (
        <div className="profile-pop-up-container">
            <Button type="text" onClick={() => { navigate(target); }}>
                {label}
            </Button>

            <Button type="text" onClick={handleLogout}>
                Log Out
            </Button>
        </div>
    );

    return (
        <div className="navbar-container">
            <div>
                <img src={TMALogo} className="navbar-logo" alt="Toyota Asia Logo"/>
            </div>
            <div className="navbar-right">
                <Popover content={content} arrow={false} trigger="click">
                    {userName && (
                        <div className="navbar-avatar-pill" style={{ cursor: "pointer" }}>
                            <div className="navbar-avatar">
                                {userName.charAt(0).toUpperCase()}
                            </div>
                            <span className="navbar-username">{userName}</span>
                        </div>
                    )}
                </Popover>
            </div>
        </div>
    );
}

export default Navbar;
